module.exports = __webpack_public_path__ + "img/schedule_sp.b71760ec.svg";